import axios from 'axios'
// 服务器
var url = 'https://v.renderg.com/'
// axios 配置
axios.defaults.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.baseURL = url

export function Get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, params)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
        }
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default {
  getVersion (params) {
    return Get(`api/v1/front/client/version/${params}`)
  },
  getNews () {
    return Get(`api/v1/common/notice/list`)
  },
  getNewData (params) {
    return Get(`pub-api/news/list?${params}`)
  },
  getNewType () {
    return Get(`pub-api/news/type`)
  }
}
